/**
 * 数据错误异常类
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/16
 * Time: 15:45
 */
import BaseExceptionError from './BaseException';

/**
 * 调用第三方API异常类
 */
export class APIExceptionError extends BaseExceptionError {
  /**
   * @param {ExceptionInfo} errExceptionInfo
   */
  // eslint-disable-next-line unicorn/custom-error-definition
  constructor(errExceptionInfo: ExceptionInfo) {
    super(errExceptionInfo.code, errExceptionInfo.message, errExceptionInfo.errDetail);
  }
}
